import { render, staticRenderFns } from "./set-password.vue?vue&type=template&id=5fd6abfa&scoped=true"
import script from "./set-password.vue?vue&type=script&lang=js"
export * from "./set-password.vue?vue&type=script&lang=js"
import style0 from "./set-password.vue?vue&type=style&index=0&id=5fd6abfa&prod&lang=scss&scoped=true"
import style1 from "./set-password.vue?vue&type=style&index=1&id=5fd6abfa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd6abfa",
  null
  
)

export default component.exports